module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8004.17b0e08b.png";